var _a;
import { PET_TYPE, RECIPE_MODE } from '@variables';
var PROFILE_SECTIONS = ['start', 'dog', 'meals', 'you', 'order'];
var PROFILE_STEPS_CONFIG = {
    start: {
        firstStepPath: '',
        sectionThreshold: 0,
    },
    dog: {
        firstStepPath: 'pet/:petIndex/name',
        sectionThreshold: 25,
    },
    meals: {
        firstStepPath: 'pet/:petIndex/meals',
        sectionThreshold: 50,
    },
    you: {
        firstStepPath: 'contact',
        sectionThreshold: 75,
    },
    order: {
        firstStepPath: 'summary',
        sectionThreshold: 100,
    },
};
var PROFILE_STEPS = {
    start: {
        section: 'start',
        progressPercentage: 0,
        theme: 'dark',
        GTMViewEvent: 'view-profile_STATUS',
    },
    petNameForm: {
        section: 'dog',
        progressPercentage: 4,
        theme: 'light',
        GTMViewEvent: 'view-dog_name',
    },
    petGenderPage: {
        section: 'dog',
        progressPercentage: 8,
        theme: 'dark',
        GTMViewEvent: 'view-gender_stop',
    },
    petGenderForm: {
        section: 'dog',
        progressPercentage: 8,
        theme: 'light',
        GTMViewEvent: 'view-gender',
    },
    petBreedPage: {
        section: 'dog',
        progressPercentage: 12,
        theme: 'dark',
        GTMViewEvent: 'view-breed_stop',
    },
    petBreedForm: {
        section: 'dog',
        progressPercentage: 12,
        theme: 'light',
        GTMViewEvent: 'view-breed',
    },
    petAgePage: {
        section: 'dog',
        progressPercentage: 16,
        theme: 'dark',
        GTMViewEvent: 'view-age_stop',
    },
    petAgeForm: {
        section: 'dog',
        progressPercentage: 16,
        theme: 'light',
        GTMViewEvent: 'view-age',
    },
    petWeightPage: {
        section: 'dog',
        progressPercentage: 20,
        theme: 'dark',
        GTMViewEvent: 'view-weight_stop',
    },
    petCurrentWeightForm: {
        section: 'dog',
        progressPercentage: 20,
        theme: 'light',
        GTMViewEvent: 'view-current_weight',
    },
    petTargetWeightForm: {
        section: 'dog',
        progressPercentage: 20,
        theme: 'light',
        GTMViewEvent: 'view-target_weight',
    },
    petHealthPage: {
        section: 'dog',
        progressPercentage: 24,
        theme: 'dark',
        GTMViewEvent: 'view-health_stop',
    },
    petPurchasingMotivationsForm: {
        section: 'dog',
        progressPercentage: 24,
        theme: 'light',
        GTMViewEvent: 'view-issues',
    },
    petHealthConcernsForm: {
        section: 'dog',
        progressPercentage: 24,
        theme: 'light',
        GTMViewEvent: 'view-health_question',
    },
    petCalculatingMealsPage: {
        section: 'dog',
        progressPercentage: 28,
        theme: 'dark',
        GTMViewEvent: 'view-profile_stop',
    },
    petMealsForm: {
        section: 'meals',
        progressPercentage: 33,
        theme: 'light',
        GTMViewEvent: 'view-meals_VERSION',
    },
    addAnotherDogForm: {
        section: 'meals',
        progressPercentage: 41,
        theme: 'dark',
        GTMViewEvent: 'view-additional_pets',
    },
    addOnsForm: {
        section: 'meals',
        progressPercentage: 49,
        theme: 'light',
        GTMViewEvent: 'view-addons',
    },
    contactForm: {
        section: 'you',
        progressPercentage: 63,
        theme: 'light',
        GTMViewEvent: 'view-contact',
    },
    addressForm: {
        section: 'you',
        progressPercentage: 74,
        theme: 'light',
        GTMViewEvent: 'view-address',
    },
    summaryForm: {
        section: 'order',
        progressPercentage: 88,
        theme: 'light',
        GTMViewEvent: 'view-summary_VERSION',
    },
};
var OTTO_PROFILE_SECTIONS = ['information', 'shipping', 'order'];
var OTTO_PROFILE_STEPS_CONFIG = {
    information: {
        firstStepPath: 'otto',
        sectionThreshold: 33,
    },
    shipping: {
        firstStepPath: 'otto/address',
        sectionThreshold: 66,
    },
    order: {
        firstStepPath: 'otto/summary',
        sectionThreshold: 100,
    },
};
var OTTO_PROFILE_STEPS = {
    petAndCustomerForm: {
        section: 'information',
        progressPercentage: 17,
        theme: 'light',
        GTMViewEvent: 'view-information_tertiary',
    },
    addressForm: {
        section: 'shipping',
        progressPercentage: 50,
        theme: 'light',
        GTMViewEvent: 'view-shipping_tertiary',
    },
    summaryForm: {
        section: 'order',
        progressPercentage: 83,
        theme: 'light',
        GTMViewEvent: 'view-summary_tertiary',
    },
};
var INITIAL_DOG_STATE = {
    petType: PET_TYPE.DOG,
    name: null,
    gender: null,
    gramsBucket: null,
    activityMultiplier: 1.1,
    quantityMultiplier: 1.0,
    recipeMode: RECIPE_MODE.FIXED,
    recipe: null,
    recipeMix: [],
    recipeRotation: [],
    currentWeight: null,
    weight: null,
    features: [],
    mealPlanItems: [],
    mealsPerDay: 1,
};
var INITIAL_PET_SURVEY_STATE = {
    purchasingMotivations: [],
};
var PURCHASING_MOTIVATION;
(function (PURCHASING_MOTIVATION) {
    PURCHASING_MOTIVATION["ALLERGIES"] = "allergies";
    PURCHASING_MOTIVATION["COAT_ISSUES"] = "coat_issues";
    PURCHASING_MOTIVATION["PICKY_EATER"] = "picky_eater";
    PURCHASING_MOTIVATION["NO_ISSUES"] = "no_issues";
})(PURCHASING_MOTIVATION || (PURCHASING_MOTIVATION = {}));
var PURCHASING_MOTIVATIONS = (_a = {},
    _a[PURCHASING_MOTIVATION.PICKY_EATER] = {
        id: PURCHASING_MOTIVATION.PICKY_EATER,
        label: 'Picky Eater',
    },
    _a[PURCHASING_MOTIVATION.COAT_ISSUES] = {
        id: PURCHASING_MOTIVATION.COAT_ISSUES,
        label: 'Dull/Flaky coat',
    },
    _a[PURCHASING_MOTIVATION.ALLERGIES] = {
        id: PURCHASING_MOTIVATION.ALLERGIES,
        label: 'Sensitive Stomach',
    },
    _a[PURCHASING_MOTIVATION.NO_ISSUES] = {
        id: PURCHASING_MOTIVATION.NO_ISSUES,
        label: 'No Issues',
    },
    _a);
var WEIGHT_STATUSES = ['ideal', 'underweight', 'overweight', 'puppy'];
var WEIGHT_STATUS_DESCRIPTIONS = {
    underweight: 'Ribs and hips highly visible, appear to jut out.',
    ideal: 'Waist and outline of ribs visible, belly tucks up.',
    overweight: 'Waist barely visible, fat deposits on the back.',
    puppy: 'Growing puppies require more calories.',
};
export { INITIAL_DOG_STATE, INITIAL_PET_SURVEY_STATE, OTTO_PROFILE_SECTIONS, OTTO_PROFILE_STEPS, OTTO_PROFILE_STEPS_CONFIG, PURCHASING_MOTIVATION, PURCHASING_MOTIVATIONS, PROFILE_SECTIONS, PROFILE_STEPS, PROFILE_STEPS_CONFIG, WEIGHT_STATUSES, WEIGHT_STATUS_DESCRIPTIONS, };
